import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetJourneyStepTraineeSessionQueryVariables = Types.Exact<{
  input: Types.GetJourneyStepTraineeSessionInput;
}>;


export type GetJourneyStepTraineeSessionQuery = { getJourneyStepTraineeSession?: { attendeeAdditionType: Types.JourneyStepSessionAttendeeAdditionType, attendeeIds: Array<string>, batchId: string, entityId: string, excludeAttendeeIds?: Array<string> | null, journeyStepId: string, trainerId: string, participantsProfiles?: Array<{ name?: string | null, id: string, profilePicture?: string | null }> | null } | null };


export const GetJourneyStepTraineeSessionDocument = /*#__PURE__*/ gql`
    query getJourneyStepTraineeSession($input: GetJourneyStepTraineeSessionInput!) {
  getJourneyStepTraineeSession(input: $input) {
    attendeeAdditionType
    attendeeIds
    batchId
    entityId
    excludeAttendeeIds
    journeyStepId
    trainerId
    participantsProfiles {
      name
      id
      profilePicture
    }
  }
}
    `;

export function useGetJourneyStepTraineeSessionQuery(options: Omit<Urql.UseQueryArgs<GetJourneyStepTraineeSessionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetJourneyStepTraineeSessionQuery, GetJourneyStepTraineeSessionQueryVariables>({ query: GetJourneyStepTraineeSessionDocument, ...options });
};